// Design tokens — single source of truth. Values match the handoff spec.

export const ACCENT = '#1B6CB5';
export const ACCENT_DARK = '#0f4a8f';
export const ACCENT_LIGHT = 'rgba(27,108,181,0.12)';
export const ACCENT_BORDER = 'rgba(27,108,181,0.28)';

export const BG = '#1a2744';
export const BG2 = '#162038';
export const CARD = '#FFFFFF';
export const CARD2 = '#F5F6F8';

export const MUTED = 'rgba(255,255,255,0.45)';
export const MUTED2 = 'rgba(255,255,255,0.2)';

export const TEXT_DARK = '#1e293b';
export const TEXT_MID = '#475569';
export const TEXT_LIGHT = '#94a3b8';

export const LIVE_GREEN = '#22c55e';
export const POST_GREY = '#94a3b8';
export const SUCCESS_GREEN = '#16a34a';
export const ERROR_RED = '#ef4444';

export const FONT = "'DM Sans', system-ui, sans-serif";
